// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "../../../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as PricingDashboardDataMachine from "../../../pricing-dashboard/app/PricingDashboardDataMachine.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as AllocationDashboardAssetsManager from "../assets/AllocationDashboardAssetsManager.bs.js";

var editIcon = AllocationDashboardAssetsManager.getImage("edit-icon.svg");

function getVehicleFromId(id, vehicleList) {
  var res = List.filter(function (vehicle) {
          return vehicle.vehicle_id === id;
        })(vehicleList);
  return Belt_List.get(res, 0);
}

function VehicleListCmp(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  React.useEffect((function () {
          var selected_region = state.selected_geo_region;
          if (selected_region !== undefined) {
            PricingDashboardDataMachine.fetchVehicleTypes(selected_region.id, (function (vehicles) {
                    var stored_vehicle_id = localStorage.getItem("selected_vehicle_id");
                    if (stored_vehicle_id !== null) {
                      var id = Belt_Int.fromString(stored_vehicle_id);
                      if (id !== undefined) {
                        var found_vehicle = List.filter(function (vehicle) {
                                return vehicle.vehicle_id === id;
                              })(vehicles);
                        var match = List.length(found_vehicle);
                        if (match !== 1) {
                          
                        } else {
                          Curry._1(dispatch, {
                                TAG: /* UpdateSelectedVehicle */4,
                                selected_vehicle: Belt_List.getExn(found_vehicle, 0)
                              });
                        }
                      }
                      
                    }
                    return Curry._1(dispatch, {
                                TAG: /* SetVehicleList */3,
                                vehicles: {
                                  TAG: /* Live */1,
                                  _0: vehicles
                                }
                              });
                  }), (function (error) {
                    return Curry._1(dispatch, {
                                TAG: /* SetVehicleList */3,
                                vehicles: {
                                  TAG: /* Error */2,
                                  _0: error
                                }
                              });
                  }), country);
          }
          
        }), []);
  React.useEffect((function () {
          var match = state.selected_vehicle;
          if (match !== undefined) {
            Curry._1(dispatch, {
                  TAG: /* UpdateCurrentView */8,
                  current_view: /* AllocationDashboardHome */3
                });
            return ;
          }
          
        }), [state.selected_vehicle]);
  var getVehicleComponentList = function (vehicles) {
    return React.createElement("div", undefined, Belt_Array.map(Belt_List.toArray(vehicles), (function (vehicle) {
                      return React.createElement("span", {
                                  key: String(vehicle.vehicle_id)
                                }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                            TAG: /* Custom */1,
                                            _0: (function (param) {
                                                return React.createElement("p", {
                                                            className: "vehicle-name"
                                                          }, vehicle.vehicle.vehicle_type);
                                              })
                                          }, undefined, (function (param) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* UpdateSelectedVehicle */4,
                                                          selected_vehicle: vehicle
                                                        });
                                            }), undefined, undefined, undefined, undefined, "vehicle", undefined, undefined)
                                    }));
                    })));
  };
  var vehicles = state.vehicles;
  var tmp;
  if (typeof vehicles === "number") {
    tmp = React.createElement(CircularLoader$Catalyst.make, {});
  } else {
    switch (vehicles.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(CircularLoader$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement("p", {
                    className: "vehicle-helper-text"
                  }, "Please pick a vehicle type to continue"), getVehicleComponentList(vehicles._0));
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: vehicles._0
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: "ald-vehicle-list-cmp-container"
            }, React.createElement("div", {
                  className: "active-vehicle-container"
                }, React.createElement("p", {
                      className: "selected-geo-location-helper-text"
                    }, "Picked Geolocation"), React.createElement("p", {
                      className: "selected-geo-location"
                    }, state.selected_geo_region.name, React.createElement(PrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Custom */1,
                                _0: (function (param) {
                                    return React.createElement(React.Fragment, undefined, React.createElement("img", {
                                                    className: "edit-icon",
                                                    src: editIcon
                                                  }), React.createElement("p", undefined, "Edit"));
                                  })
                              }, false, (function (_event) {
                                  return Curry._1(dispatch, /* ClearSelectedGeoRegion */2);
                                }), undefined, undefined, undefined, undefined, "edit-geo-region-button", undefined, undefined)
                        })), React.createElement("div", {
                      className: "vehicle-section-body"
                    }, tmp)));
}

var make = VehicleListCmp;

export {
  editIcon ,
  getVehicleFromId ,
  make ,
  
}
/* editIcon Not a pure module */
